import { createAction, createReducer, on, props } from '@ngrx/store';
import { LoadingStatusInitState } from '../models/loading-status.interface';

// Actions
export const STORE_LOADED = createAction(
  '[LoadingStatus] Store Loaded',
  props<{ storeLoaded: boolean }>()
);

export const COPY_LOADED = createAction(
  '[LoadingStatus] Copy Loaded',
  props<{ copyLoaded: boolean }>()
);

export const AIRPORT_COPY_LOADED = createAction(
  '[LoadingStatus] Airport Copy Loaded',
  props<{ airportCopyLoaded: boolean }>()
);

export const RULES_COPY_LOADED = createAction(
  '[LoadingStatus] Rules Copy Loaded',
  props<{ rulesCopyLoaded: boolean }>()
);

export const CURRENT_BOOKING_LOADED = createAction(
  '[LoadingStatus] Current Booking Loaded',
  props<{ currentBookingLoaded: boolean }>()
);

export const FLIGHT_LOADED = createAction(
  '[LoadingStatus] Flight Loaded',
  props<{ flightLoaded: boolean }>()
);

export const USER_LOADED = createAction(
  '[LoadingStatus] User Loaded',
  props<{ userLoaded: boolean }>()
);

export const PRICE_LOADED = createAction(
  '[LoadingStatus] Price Loaded',
  props<{ priceLoaded: boolean }>()
);

export const PARTNER_LOADED = createAction(
  '[LoadingStatus] Partner Loaded',
  props<{ partnerLoaded: boolean }>()
);

export const AIRPORTS_LOADED = createAction(
  '[LoadingStatus] Airports Loaded',
  props<{ airportLocationsLoaded: boolean }>()
);

// Initial State
const initState: LoadingStatusInitState = {
  storeLoaded: false,
  copyLoaded: false,
  partnerLoaded: false,
  bookingState: false,
  currentBookingLoaded: false,
  userLoaded: false,
  priceLoaded: false,
  flightLoaded: false,
  airportLocationsLoaded: false,
  airportCopyLoaded: false,
  rulesCopyLoaded: false,
};

// Reducer
export const loadedStatusReducer = createReducer(
  initState,

  on(STORE_LOADED, (state, { storeLoaded }) => ({
    ...state,
    storeLoaded,
  })),

  on(COPY_LOADED, (state, { copyLoaded }) => ({
    ...state,
    copyLoaded,
  })),

  on(AIRPORT_COPY_LOADED, (state, { airportCopyLoaded }) => ({
    ...state,
    airportCopyLoaded,
  })),

  on(RULES_COPY_LOADED, (state, { rulesCopyLoaded }) => ({
    ...state,
    rulesCopyLoaded,
  })),

  on(CURRENT_BOOKING_LOADED, (state, { currentBookingLoaded }) => ({
    ...state,
    currentBookingLoaded,
  })),

  on(FLIGHT_LOADED, (state, { flightLoaded }) => ({
    ...state,
    flightLoaded,
  })),

  on(USER_LOADED, (state, { userLoaded }) => ({
    ...state,
    userLoaded,
  })),

  on(PRICE_LOADED, (state, { priceLoaded }) => ({
    ...state,
    priceLoaded,
  })),

  on(PARTNER_LOADED, (state, { partnerLoaded }) => ({
    ...state,
    partnerLoaded,
  })),

  on(AIRPORTS_LOADED, (state, { airportLocationsLoaded }) => ({
    ...state,
    airportLocationsLoaded,
  }))
);
